export default __webpack_public_path__ + "static/media/_avatar-3.65f48ef2.jpg";